import { Component, Input } from '@angular/core';
import { ProvisionStatus } from '../../enums/provision-status.enum';

@Component({
  selector: 'account-status-bar',
  templateUrl: './account-status-bar.component.html',
  styleUrl: './account-status-bar.component.scss'
})
export class AccountStatusBarComponent {
  @Input() account:any;

  statusSteps: string[] = [
    "Account Creation - ",
    "IP Range Request - ",
    "Account Provisioning - ",
    "Completed",
  ];

  currentStep: number = 0; 
  currentStepStatus: number = 0;

  currStatusIcon: string = 'loader';
  stepNameText: string = "Account Provisioning - ";
  stepStatusText: string = "In progress";    

  constructor() { }

  ngOnInit(): void {
    console.log(this.account)

    const { account_status, provision_status }: { account_status: number; provision_status: number } = this.getStatus();
    [this.currentStep, this.currentStepStatus] = this.getCurrentStep(account_status, provision_status);

    this.stepNameText = this.statusSteps[this.currentStep];

    switch(this.currentStepStatus){
      case 1: 
        this.currStatusIcon = 'circle-check-green';
        this.stepNameText = "";
        this.stepStatusText = "Complete";
        break;
      case 2: 
        this.currStatusIcon = 'error-pulse';
        this.stepStatusText = "Error. Please contact Albus Dumbledore at dumbledore@gm.com";
        break;
      default:
        this.currStatusIcon = "loader";
        this.stepStatusText = "In progress"; 
    }
  }

  // TODO: Change to use API to get statuses
  // API Now returns BOTH provision status and account status
  getStatus() : { provision_status: number; account_status: number }{
    // return ProvisionStatus[this.account.status].toLowerCase();
    return {
      "account_status" : 1,
      "provision_status" : 2,

    }
  }

  /**
   * Retrieves the current step out of 4 account + infrastructure provisioning is at
   * There are 4 possible
   * @param account_status - enum value indicating account creation status
   * @param provision_status - enum value indicating infrastructure provisioning status
   * @returns a number between 0-3 excluding 1
   */
  getCurrentStep(account_status: number, provision_status: number): [number, number]{
    if (account_status != 1){
      return [0, account_status]
    }else{
      return provision_status == 1 ? [3, provision_status] : [2, provision_status];
    }
  }

  /**
   * Sets CSS class for a given status step based on its index relative to
   * the current step and the current status for account and provision
   * Front end use only
   * @param index comes from the front end and is index of the segment 
   *  being generating
   * @returns A string representing the CSS class for the step
   */
  setStatusStepClass(index: number){
    if (index > this.currentStep){
      return 'future-step'
    }else if (index < this.currentStep){
      return 'completed'
    }else{
      return this.setProvisionStatus();
    }
  }

  /**
   * @returns enum value for the current status of account provisioning
   */
  setProvisionStatus() : string{
    return ProvisionStatus[this.currentStepStatus].toLowerCase();
  }


}
